import { createBrowserHistory } from 'history';

const baseHref = document
  .querySelector('base')
  .getAttribute('href')
  .replace(/\/$/, '');

export default createBrowserHistory({ basename: baseHref });
